import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const coapplicantResidenceSectionComponent = {
  address: 'coapplicant-residence-section.address',
  amount: 'coapplicant-residence-section.amount',
  duration: 'coapplicant-residence-section.duration',
  editLink: 'coapplicant-residence-section.edit-link',
  h3: 'coapplicant-residence-section.h3',
  residenceType: 'coapplicant-residence-section.residence-type',
  root: 'coapplicant-residence-section.root',
} as const satisfies ComponentLocatorMap;
